export default (pixels, adjustment) => {
    const d = pixels.data;
    for (let i = 0; i < d.length; i += 4) {
        d[i] += adjustment;
        d[i + 1] += adjustment;
        d[i + 2] += adjustment;
    }
    return pixels;
};
